import React, { useEffect, useState } from "react";
import TableTrader from "./TableTraderComponent/TableTrader";

import CalendarIcon from "../../icons/calendor-icon.png";
import { formatDMY, PrimaryColor } from "../../common";
import FilterTraderComponent from "./FilterTraderComponent/FilterTraderComponent";
import { getTraderBlockData } from "../../Rest_api/RestApi";
import { ChartTraderComponent } from "./ChartTraderComponent/ChartTraderComponent";
import Loading from "../../components/Loading";
import { Calendar } from "react-date-range";
import { DynamicDatePicker } from "../../components/DatePicker";
import { formatDateForAPI } from "../Rajasthan/Utility/const";

const TABS = ["Chart", "Table"];

// export const formatDateString = (date) => {
//   if (!(date instanceof Date)) {
//     date = new Date(date);
//   }
//   date.toLocaleDateString("en-GB").split("/").reverse().join("-");
// };

export const formatDateString = (date) => {
  if (!(date instanceof Date)) {
    date = new Date(date);
  }
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const MainTraderComponent = () => {
  const [visible, setVisible] = useState(false);
  const [filterType, setFilterType] = useState({
    label: "Time Slot",
    key: "time",
    values: ["time", "date"],
    isTime: true,
  });
  const [state, setState] = useState({
    startDate: new Date("2024-01-01"),
    endDate: new Date("2024-01-06"),
    key: "selection",
  });
  const [dateRange, setDateRange] = useState({
    startDate: new Date("2024-01-01"),
    endDate: new Date("2024-01-06"),
    key: "selection",
  });
  const [selectedTab, setSelectedTab] = useState("Chart");
  const [fullData, setFullData] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedFilters, setSelectedFilters] = useState({});

  useEffect(() => {
    fetchData();
  }, [dateRange, selectedFilters]);

  const handleSelectFilter = (filter) => {
    setFilterType(filter);
  };

  async function fetchData() {
    setLoading(true);
    try {
      const fetchedData = await getTraderBlockData({
        startDate: formatDateForAPI(dateRange.startDate),
        endDate: formatDateForAPI(dateRange.endDate),
        trader: selectedFilters["trader"],
        product: selectedFilters["product"],
        state_of_buyer: selectedFilters["state"],
        state_of_seller: selectedFilters["state"],
        name_of_seller: selectedFilters["name"],
        name_of_buyer: selectedFilters["name"],
        category_of_seller: selectedFilters["category"],
        category_of_buyer: selectedFilters["category"],
        transaction_type: selectedFilters["transaction_type"],
      });

      setFullData(fetchedData);

      if (fetchedData.length > 0) {
        setLoading(true);
        setData(fetchedData);
      } else {
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching trader data:", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  }

  const handleFilterData = (selectFilter) => {
    setSelectedFilters(selectFilter);
    // if (filteredResults.length > 0) {
    //   setData(filteredResults);
    // } else {
    //   setData([]);
    // }
  };

  return (
    <div className="auction-container">
      <div className="header">
        <h1>Trader</h1>
        <DynamicDatePicker
          minDate="2018-01-01"
          maxDate="2024-09-31"
          defaultDates={state}
          setDate={(date) =>
            setDateRange({
              startDate: date[0].startDate,
              endDate: date[0].endDate,
              key: "selection",
            })
          }
        />
      </div>
      <div>
        <FilterTraderComponent
          data={data}
          setSelectedFilters={setSelectedFilters}
          handleFilterData={handleFilterData}
          handleSelectFilter={handleSelectFilter}
          filterType={filterType}
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
        />
      </div>
      {loading ? (
        <div className="loader">
          <Loading />
        </div>
      ) : selectedTab === TABS[0] ? (
        <ChartTraderComponent
          data={data}
          fetchTraderData={fetchData}
          selectedFilters={selectedFilters}
          handleFilterData={handleFilterData}
          Intervals={filterType}
        />
      ) : (
        <TableTrader data={data} />
      )}
    </div>
  );
};

export default MainTraderComponent;
